import styled from '@emotion/styled/macro'
import { ListGroup } from 'react-bootstrap'

import { flexCenter, pageContentDefaultSize } from 'style/emotion'
import mediaQuery from 'share/utils/mediaQuery'

const CaseLevelDashPage = styled('section')`
  ${pageContentDefaultSize}

  color: var(--CINight);
  margin-top: 48px;

  > h2 {
    margin-bottom: 16px;
  }

  ${mediaQuery('tablet')} {
    margin-top: 24px;
  }
`

const HeroImageContainer = styled('div')`
  width: 100%;

  .hero-image {
    width: 100%;
    height: 300px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center bottom;
  }

  .case-pre-filing {
    ${mediaQuery('tablet')} {
      background-position: center bottom;
      height: 150px;
    }

    ${mediaQuery('laptop', 'tablet')} {
      background-position: center bottom;
      height: 250px;
    }
    ${mediaQuery('desktop', 'laptop')} {
      background-position: center -420px;
      height: 300px;
    }
    @media (min-width: 1600px) and (max-width: 1800px) {
      background-position: center -580px;
    }
    @media (min-width: 1800px) {
      background-position: center -670px;
    }
  }

  .case-filed {
    ${mediaQuery('tablet')} {
      background-position: center center;
      height: 150px;
    }

    @media (min-width: 768px) and (max-width: 950px) {
      background-position: center -190px;
      height: 250px;
    }

    @media (min-width: 951px) and (max-width: 1199px) {
      background-position: center -270px;
      height: 250px;
    }

    ${mediaQuery('desktop', 'laptop')} {
      background-position: center -350px;
      height: 300px;
    }
    @media (min-width: 1600px) and (max-width: 1800px) {
      background-position: center -490px;
    }

    @media (min-width: 1800px) {
      background-position: center -550px;
    }
  }

  .case-complete {
    ${mediaQuery('tablet')} {
      background-position: center center;
      height: 150px;
    }

    ${mediaQuery('laptop', 'tablet')} {
      background-position: center center;
      height: 250px;
    }

    ${mediaQuery('desktop', 'laptop')} {
      background-position: center -280px;
      height: 300px;
    }
    @media (min-width: 1600px) and (max-width: 1800px) {
      background-position: center -400px;
    }
    @media (min-width: 1800px) {
      background-position: center -480px;
    }
  }
`

const CaseLevelDashToKnowContainer = styled('div')`
  margin-top: 10px;

  > div {
    ${flexCenter}

    justify-content: space-between;

    > h3 {
      margin: 0;
      color: var(--print-secondary);
    }
  }
`

const CaseLevelDashDescription = styled('p')`
  margin: 0;
  margin-top: 16px;
`

const CaseLevelDashToDoContainer = styled('div')`
  margin-top: 24px;

  > h4 {
    margin-bottom: 16px;
  }

  .case-level-dashboard-completed-all-tasks-message {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1rem;

    > .case-level-dashboard-completed-all-task-message-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 80px;
      height: 80px;
      border-radius: 80px;
      background-color: var(--london-fog);
      .mdi {
        font-size: 48px;
        color: var(--gray-1);
        margin-top: 6px;
      }
    }

    .case-level-dashboard-completed-all-task-message-text {
      font-size: 14px;
      font-weight: 400;
      line-height: 15px;
      color: var(--slate-60);
    }
  }
`

const List = styled(ListGroup)`
  border-radius: 0;

  > button {
    align-items: center;
    background-color: var(--london-fog);
    border: 1px solid var(--gray-2);
    display: flex;
    font-size: 1rem;
    font-weight: 300;
    min-height: 40px;
    justify-content: space-between;
    padding: 0 16px;

    > span {
      font-size: 1.5rem;
    }
  }
`

const CaseLevelDashBtnList = styled('div')`
  ${flexCenter}

  margin-top: 32px;
  flex-direction: column;
  gap: 16px;

  > button {
    width: 90%;
    ${mediaQuery('tablet', 'mobile')} {
      max-width: 266px;
    }

    ${mediaQuery('', 'tablet')} {
      max-width: 302px;
    }

    height: 40px;

    > a {
      color: var(--print-main);

      :active,
      :hover {
        background-color: var(--gray-2);
        text-decoration: none;
      }
    }
  }

  ${mediaQuery('mobile')} {
    flex-wrap: wrap;
    margin-top: 24px;
  }
`

export {
  CaseLevelDashBtnList,
  CaseLevelDashDescription,
  CaseLevelDashPage,
  CaseLevelDashToDoContainer,
  CaseLevelDashToKnowContainer,
  List,
  HeroImageContainer
}
